import React, {useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { useNavigate } from 'react-router-dom';
import { Row, Col,Radio, Switch, RadioChangeEvent,Button } from "antd";
import { useAppDispatch,useAppSelector } from "../../redux/store/storehooks";
import { login,logout, waitForTaxInfo } from "../../redux/reducers/authSlice";
import { ButtonContainer, ForgetPassowedContainer, FormContainerDiv, FormGroup, LoginMainSection, LoginTypeContainer, MainFormContainer, WelcomeTitleLable } from './style';
import Input from "../../components/_common/Input";
import { useForm } from '../../utility/useForm';
import { validateLoginForm } from '../../utility/validationRules';
import { forgetPassword, generateAuthToken, getMachineList, getState, labuserLogin, parsiuserLogin } from '../../api/api';
import { ValidationErrorSpan } from '../../styles/global';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import CustomFooter from '../../components/footer/CustomFooter';
import FormContainer from '../../components/FormContainer/FormContainer';
import { TaxInfoDialog } from './taxInfoDialog';
import { UpdatePasswordDialog } from "./updatePasswordDialog";
import { getFromStorage, setToStorage } from '../../services/localstorage.service';
import { customTTL } from '../../constants';
import { LabInstallationRequestDialog } from '../lab/LabInstallationRequestDialog';

export interface ValidationTypeProps {
    type: any;
}


  

const Login = () => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(validateLoginForm) as any;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    // const bgPath = process.env.PUBLIC_URL + `/assets/svg/backtwo.svg`;
    const bgPath = process.env.PUBLIC_URL + `/assets/image/111-scaled.png`;
    const loginTypeOptions = [{ label: 'پرسنل آزمایشگاه', value: 'labuser' },{ label: 'پرسنل پارسی پل', value: 'parsicuser' }]
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [showTaxInfoDialog,setShowTaxInfoDialog] = useState(false);
    const [taxInfoDialogPayload,setTaxInfoDialogPayload] = useState({Str_Address:"",str_Economicode:"",str_PostalCode:"",str_TaxFullNameOwnernationalCode:"",str_TaxnationalCode:"",Str_DirectTel:""});
    const [showUpdatePasswordDialog,setShowupdatePasswordDialog] = useState(false);
    const [updatePasswordDialogPayload,setUpdatePasswordDialogPayload] = useState({oldPassword:"",labId:0});
    const [showRegisterNewCustomerDialog,setShowRegisterNewCustomerDialog] = useState(false);
    const [registerNewCustomerDialogPayload,setRegisterNewCustomerDialogPayload] = useState({state:undefined,machineList:undefined});

    const ValidationType = ({ type }: ValidationTypeProps) => {
        const ErrorMessage = errors[type];   
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
      };

      useEffect(() => {
     
        setValues((values:any) => ({
            ...values,
            ["logintype"]: 'labuser',
          }));
    }, [])
    const FormSubmit = (e:any) => {
        e.preventDefault();

        let jwt = getFromStorage("jwt");
        if (!jwt){
            makeAuthToken("login");
            return;
        }
        
        let error= validateLoginForm(values);
        if (Object.keys(error).length == 0)
        {
          
            doLogin();  
        }
        else
        {
          setErrors(error);
        }
               
    }

    const makeAuthToken = (caller:any) => {

        setIsSubmiting(true)

        generateAuthToken()
        .then((result:any) => {
            setIsSubmiting(false)
            setToStorage("jwt",result.data.token)

            if (caller === "login")
            {
                doLogin();
            }
            else if (caller === "register")
            {
                registerNewCustomers();
            }
            
            
            setTimeout(() => {
                console.log("automatic signout");
                errorNotify("توکن دسترسی به سامانه منقضی شده است",undefined,5000)
                errorNotify("مجددا وارد سامانه شوید",undefined,5000)
                dispatch(logout());
              }, customTTL * 1000)

            
        })
        .catch((error) => {
            setIsSubmiting(false)
            console.log(error.response);
            errorNotifyByErrorObject(error,undefined,5000)
        })

    }

    const doLogin = () => {

        console.log("doLogin");

        if (values.logintype == "labuser"){
                
            setIsSubmiting(true)

            labuserLogin(values)
            .then((result:any) => {

                setIsSubmiting(false)

                if (values.userName === values.password)
                {
                    setUpdatePasswordDialogPayload({...updatePasswordDialogPayload,oldPassword:values.password,
                        labId:result.data.data.Prk_AndriodLab_AutoID})
                    errorNotify("در اولین ورود نیاز به تغییر گذرواژه می باشد")
                    setShowupdatePasswordDialog(true)
                    return;
                }


                let {Str_Address,str_Economicode,str_PostalCode,str_TaxFullNameOwnernationalCode,str_TaxnationalCode} = result.data.data.taxInfo
                let Str_DirectTel = result.data.data.Str_DirectTel

                if (Str_Address === "" || str_Economicode === "" || str_PostalCode === "" || str_TaxFullNameOwnernationalCode === "" || str_TaxnationalCode === ""){
                    dispatch(waitForTaxInfo({loginType:"labuser",
                    userId:result.data.data.Prk_AndriodLab_AutoID,
                    userTitle:result.data.data.Str_LabPersianName}))
                    setTaxInfoDialogPayload({...taxInfoDialogPayload,Str_Address,str_Economicode,
                        str_PostalCode,str_TaxFullNameOwnernationalCode,str_TaxnationalCode,Str_DirectTel})
                    errorNotify("اطلاعات مالیاتی آزمایشگاه را وارد نمایید") 
                    setShowTaxInfoDialog(true)
                    return;
                }
                
                dispatch(login({loginType:"labuser",userId:result.data.data.Prk_AndriodLab_AutoID,
                userTitle:result.data.data.Str_LabPersianName,taxInfo:result.data.data.taxInfo,
                permission:undefined,
                
                manager:result.data.data.manager
                ,int_minimumpayment:result.data.data.int_minimumpayment,
                }))
                navigate("/labuser/dashboard");
                sucessNotify(result.data.data.Str_LabPersianName + " خوش آمدید")

            })
            .catch((error) => {
            setIsSubmiting(false)
              console.log(error.response);
              errorNotifyByErrorObject(error,undefined,5000)
            })
        }
        else
        {

            setIsSubmiting(true)

            parsiuserLogin(values)
            .then((result:any) => {
                
                setIsSubmiting(false)
                dispatch(login({loginType:"parsicuser",userId:result.data.data.id,userTitle:result.data.data.name,
                taxInfo:undefined,permission:result.data.data.userMenuAccesses,
                manager:result.data.data.manager
            ,int_minimumpayment:result.data.data.int_minimumpayment,
            }))
                navigate("/parsicuser/dashboard");
                sucessNotify(result.data.data.name + " خوش آمدید")
            })
            .catch((error) => {
                setIsSubmiting(false)
                console.log(error.response);
                errorNotifyByErrorObject(error,undefined,5000)
            })
        }     
        
    }

    const logintypeChange = ({ target: { value } }: RadioChangeEvent) => {

        setValues((values:any) => ({
            ...values,
            ["logintype"]: value,
          }));
          
    };

    const forgetPassowrd = () => {

        if (values.userName === undefined || values.userName === null || values.userName ===""){
            errorNotify("لطفا نام کاربری خود را وارد کنید")
            return;
        }

        forgetPassword(values.userName)
        .then((result:any) => {
            console.log(result.data)
            sucessNotify(result.data.data)
        })
        .catch((error) => {
        setIsSubmiting(false)
          console.log(error.response);
          errorNotifyByErrorObject(error,undefined,5000)
        })

    }


    const registerNewCustomers = () => {

        let jwt = getFromStorage("jwt");
        if (!jwt){
            makeAuthToken("register");
            return;
        }

        getState()
        .then((result:any) => {
            setRegisterNewCustomerDialogPayload((values:any) => ({
                ...values,
                state: result.data.data,
              }));
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000);
        })
        
        

        getMachineList()
        .then((result:any) => {

            setRegisterNewCustomerDialogPayload((values:any) => ({
                ...values,
                machineList: result.data.data,
              }));

        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000);
        })     

        setShowRegisterNewCustomerDialog(true);
    }

    return (
        <>
            <LoginMainSection
            
            src={bgPath}>

                <MainFormContainer  >

                    <FormContainer     
                    title="" saveButtonTitle={'ورود به سیستم'} 
                    cancelButtonTitle={''} extraButtonTitle={values.logintype == "parsicuser" ? undefined : "ثبت نام مشتری جدید"} onExtraClick={() => registerNewCustomers()} onSubmit={FormSubmit} onCancel={undefined} isLoading={false}  isSubmiting={isSubmiting} >
                        <FormContainerDiv  >
                                    <Row>
                                        <Col lg={24} md={24} sm={24} xs={24}>
                                            <WelcomeTitleLable  style={{fontWeight:'normal'}}>
                                            <img src='/assets/image/logo.png' height={20} 
                                            style={{paddingLeft:'10px'}} />
                                            <span style={{display:'inline-block'}}>
                                            به پنل مشتریان 
                                            </span>
                                               
                                                <span style={{padding:'0px 10px',display:'inline-block',color:'#3e70b2'}}>
                                                پارسی پل
                                                </span>
                                                
                                               
                                                 خوش آمدید
                                                
                                                </WelcomeTitleLable>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col lg={24} md={24} sm={24} xs={24}>
                                            <LoginTypeContainer>
                                                <Radio.Group
                                                    name="logintype"
                                                    options={loginTypeOptions}
                                                    onChange={logintypeChange}
                                                    value={values.logintype || "labuser"}
                                                    optionType="button"
                                                    buttonStyle="solid"
                                                />
                                            </LoginTypeContainer>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Input
                                            type="text"
                                            name="userName"
                                            // placeholder={t("ContactForm_TitlePlaceHolder")}
                                            placeholder="نام کاربری"
                                            value={values.userName || ""}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="userName" />
                                    </Row>
                                    <Row>
                                        <Input
                                            name="password"
                                            // placeholder={t("ContactForm_TitlePlaceHolder")}
                                            placeholder="گذرواژه"
                                            value={values.password || ""}
                                            onChange={handleChange}
                                            type="password"
                                        />
                                        <ValidationType type="password" />
                                    </Row>

                                    {values.logintype == "labuser" && (
                                        <Row>
                                            <ForgetPassowedContainer>
                                                <a onClick={forgetPassowrd}>رمز عبور خود را فراموش کردید؟</a>
                                            </ForgetPassowedContainer>
                                        </Row>
                                    )}

                        </FormContainerDiv>

                    </FormContainer>

                    {/* <FormGroup onSubmit={FormSubmit}>
                            <FormContainerDiv>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <WelcomeTitleLable>به پنل مشتریان پارسی پل خوش آمدید</WelcomeTitleLable>
                                    </Col>
                                </Row>  
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <LoginTypeContainer>
                                            <Radio.Group
                                                name="logintype"
                                                options={loginTypeOptions}
                                                onChange={logintypeChange}
                                                value={values.logintype || "parsicuser"}
                                                optionType="button"
                                                buttonStyle="solid"
                                            />
                                        </LoginTypeContainer>
                                    </Col>
                                </Row>
                                <Row>
                                    <Input
                                        type="text"
                                        name="userName"
                                        // placeholder={t("ContactForm_TitlePlaceHolder")}
                                        placeholder="نام کاربری"
                                        value={values.title || ""}
                                        onChange={handleChange}
                                    />
                                    <ValidationType type="userName" />
                                </Row>
                                <Row>
                                    <Input
                                        type="text"
                                        name="password"
                                        // placeholder={t("ContactForm_TitlePlaceHolder")}
                                        placeholder="گذرواژه"
                                        value={values.title || ""}
                                        onChange={handleChange}
                                    />
                                    <ValidationType type="password" />
                                </Row>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <ButtonContainer>
                                            <Button type='submit'>ورود به سیستم</Button>
                                        </ButtonContainer>
                                    </Col>   
                                    
                                </Row>
                            </FormContainerDiv>
                    </FormGroup> */}

                </MainFormContainer>

                <CustomFooter/>

                {showTaxInfoDialog && (
                    <TaxInfoDialog
                        visible={showTaxInfoDialog}
                        onSubmit={() => console.log(true)}
                        onCancel={() => { setShowTaxInfoDialog(false)}}
                        payLoad={taxInfoDialogPayload}
                        setShowDialog={(value) => setShowTaxInfoDialog(value)}
                    />
                )}

                {showUpdatePasswordDialog && (
                    <UpdatePasswordDialog
                        visible={showUpdatePasswordDialog}
                        onSubmit={() => console.log(true)}
                        onCancel={() => { setShowupdatePasswordDialog(false)}}
                        payLoad={updatePasswordDialogPayload}
                        setShowDialog={(value) => setShowupdatePasswordDialog(value)}
                    />
                )}

                {showRegisterNewCustomerDialog && (
                    <LabInstallationRequestDialog
                        visible={showRegisterNewCustomerDialog}
                        onSubmit={() => console.log(true)}
                        onCancel={() => setShowRegisterNewCustomerDialog(false)}
                        payLoad={registerNewCustomerDialogPayload}
                        setShowDialog ={() => setShowRegisterNewCustomerDialog(false)}
                    />
                )}

            </LoginMainSection>
        </>
    );
};

export default Login
